<template>
    <div>
        <div class="py-4 d-none">
            <div class="dropdown">
                <div class="alert alert-secondary" role="alert">
                    <p class="lead">Welcome Back, {{this.userData.user}}</p>
                    <p v-if="this.isAdmin"><em>Administrator</em></p>
                    <p v-else><em>{{this.userData.roles}}</em></p>
                </div>
            </div>
        </div>
        <div class="content-header text-center">
            <h2>User Management</h2>
        </div>
        <div class="container-fluid min-content-height">
            <div class="row">
                <div class="col">
                    <div class="card card-body">
                        <h3 class="text-center">Users</h3>
                    <table class="table">
                        <thead>
                            <tr>
                            <th scope="col">UID</th>
                            <th scope="col">Username</th>
                            <th scope="col">Email</th>
                            <th scope="col">Manage</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="option in userlistdata">
                                <td>{{ option.uid }}</td>
                                <td>{{ option.user }}</td>
                                <td>{{ option.email }}</td>
                                <td>
                                    <button class="btn btn-sm btn-default ms-1" @click="$emit('updateUserRole', {updateuid: option.uid})">Toggle Admin</button> 
                                    <button class="btn btn-sm btn-info ms-1" v-on:click="load_user(option.uid, 'manage_user')">User</button> 
                                    <button v-on:click="load_user(option.uid, 'manage_session')" class="btn btn-sm btn-primary ms-1">Session</button> 
                                    <button class="btn btn-sm btn-warning ms-1" v-on:click="load_user(option.uid, 'manage_scripts')">Features</button> 
                                    <button class="btn btn-sm btn-danger ms-1" v-on:click="delete_user(option.uid)">Delete</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                
            </div>
            <div class="row">
                <div class="col">
                    <div class="card card-body">
                    <h3 class="text-center">Delete Specific Session</h3>
                    <p class="text-center">When deleting a user (above) any associated sessions using the same UID will also be deleted. However if a session exists without a user, then enter the UID for the session here to remove it.</p>
                    <form id="sessiondelete" method="post" @submit.prevent="deleteSession">
                        <div class="form-group">
                            <label class="form-label">Enter UID</label>
                            <input class="form-control form-control-lg" name="deletionuid" id="deletionuid" placeholder="ie. 7UARKWJ1SAJQ" />
                        </div>
                        <div class="form-group float-end">
                            <button type="submit" class="btn btn-lg btn-primary">Delete Session</button>
                        </div>
                    </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'UserList',
    props: {
        userData: [],
        isAdmin: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data(){
        return{
            userlistdata: '',
            userdata: '',
            sessiondata: '',
            scriptdata: ''
        }
    },
     methods: {  
        load_user(userid, querytype) {
            console.log('querytype is '+querytype);
            if(querytype == 'manage_user') {
                var endPointURL = '/load_user';
            } else if(querytype == 'manage_session') {
                var endPointURL = '/load_session';
            } else if(querytype == 'manage_scripts') {
                var endPointURL = '/load_scripts';
            }
            let formData = new FormData();
            formData.append('deletionuid', userid);
            axios({
                method : 'POST',
                url : endPointURL,
                data: formData
            }).then(
            (response) => {
                if(querytype == 'manage_user') {
                    this.userdata = response.data;
                    console.log(JSON.stringify(this.userdata));
                    this.$emit('openModal', {view: 'ModalEditUsersData', dt: this.userdata})
                } else if(querytype == 'manage_scripts') {
                    console.log('scripts modal selected');
                    this.scriptdata = response.data;
                    console.log(JSON.stringify(this.scriptdata));
                    this.$emit('openModal', {view: 'ModalEditScriptsData', dt: this.scriptdata})
                } else {
                    this.sessiondata = response.data;
                    this.$emit('openModal', {view: 'ModalEditUsersSession', dt: this.sessiondata})
                    console.log(JSON.stringify(this.sessiondata));
                }                
            }
            )
            .catch(
            (error) => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                }
            );
        },
        delete_user(userid) {
            let formData = new FormData();
            formData.append('deletionuid', userid);
            axios({
                method : 'POST',
                url : '/delete_user',
                data: formData
            }).then(
            (response) => {
                console.log(JSON.stringify(response.data));
                this.$emit('customChange', {shell: 'UserList', dataset: ''});
            }
            )
            .catch(
            (error) => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                }
            );
        },
        deleteSession() {
            const intialFormData = new FormData(document.getElementById("sessiondelete"));
            const serializedSessionId = new URLSearchParams(intialFormData).toString();
            axios({
                method : 'POST',
                url : '/delete_session',
                data: serializedSessionId
            }).then(
            (response) => {
                console.log(JSON.stringify(response.data));
                this.$emit('customChange', {shell: 'UserList', dataset: ''});
            }
            )
            .catch(
            (error) => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                }
            );
        }
    },
    mounted() {
        axios.get('/list_all_users')
      .then(
          (response) => {
              this.userlistdata = response.data;
              console.log('JSON/Stringify data response: '+JSON.stringify(this.userlistdata));
        })
        .catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
    }
}

</script>